















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { FourRubbingData, emptyFourRubbing } from '@/api/heritageUnit/unitFour'
import { fileServer, thumbnailServer } from '@/api/common/upload'
import { newGuid } from '@/configs/functions'
import { AttachInfo } from '@/api/common/attach'
import ElementUI from 'element-ui'

@Component
export default class UnitFourRubbingView extends Vue {
  public name = 'UnitFourRubbingView'

  @Prop({ default: '300px' })
  public maxHeight!: String
  @Prop({ default: 1 }) //1拓片 2摹本
  public category: number = 1

  get categoryName(): String {
    return this.category == 1 ? '拓片' : '摹本'
  }
  @Prop({ default: [] })
  public dataList!: FourRubbingData[]
  //由父级传入
  // public dataList: FourRubbingData[] = []
  public setData(data: FourRubbingData[]) {
    this.dataList = data
  }
  public getOrgFile(f: AttachInfo) {
    return fileServer(f.Id, f.TempGuid, f.Name)
  }
  public getFileUrl(f: AttachInfo) {
    return thumbnailServer(f.Id, f.TempGuid, f.Name)
  }
  public rowClick(row: any, index: any, e: any) {
    this.$refs.refTable.toggleRowExpansion(row)
  }

  // dynamic component
  public $refs!: {
    refTable: ElementUI.Table
  }
  public mounted() {}
  public beforeDestroy() {}
}
